module.exports = __webpack_public_path__ + "images/LMS.81b65687.webp";